export default "__VITE_ASSET__911y7W_e__"